export default __webpack_public_path__ + "static/media/user-07.7d2fc5cc.jpg";